import { useState } from 'react'

import { getFaq, getFaqData } from '../../api/faq'
import useApiCall from '../../api/useApiCall'
import { useCapabilities } from '../../hooks/useCapabilities'
import LoadingSection from '../LoadingSection/LoadingSection'

import FaqExamplesSection from './FaqExample/FaqExample'
import FaqItems from './FaqItem/FaqItem'
import FaqResponsesSection from './FaqResponse/FaqResponse'

import styles from './faq.module.scss'

function Faq() {
    const [editedFaqs, setEditedFaqs] = useState<string[]>([])
    const [selectedFaqItem, setSelectedFaqItem] = useState<string>('')

    const { canDeleteFaq } = useCapabilities()

    const clearCurrentFaqDataState = () => {
        setSelectedFaqItem('')
    }

    const [{ data: faqs, loading }, { refetch }] = useApiCall(
        getFaq,
        clearCurrentFaqDataState
    )

    const [
        { data: faqData, loading: isFaqDataLoading },
        { refetch: refetchFaqData },
    ] = useApiCall(getFaqData, undefined, selectedFaqItem)

    const handleAddItemClick = (newItem: string) => {
        const toAdd =
            newItem.trim() !== '' &&
            !faqs?.includes(newItem) &&
            !editedFaqs.includes(newItem)

        if (toAdd) {
            setEditedFaqs([newItem, ...editedFaqs])
        }
    }

    const displayedFaqs = [
        ...(editedFaqs.filter((faq) => !faqs?.includes(faq)) || []),
        ...(faqs || []),
    ]

    return (
        <main className={styles.faq}>
            <div className={styles.faq__header}>
                <h1 className={styles.faq__header__title}>FAQ</h1>
            </div>

            <div className={styles.faq__items}>
                {loading ? (
                    <LoadingSection />
                ) : (
                    faqs && (
                        <FaqItems
                            data={displayedFaqs}
                            onItemClick={setSelectedFaqItem}
                            onAddItemClick={handleAddItemClick}
                            fetchFaqData={refetch}
                            clearCurrentFaqDataState={clearCurrentFaqDataState}
                            canDelete={canDeleteFaq}
                        />
                    )
                )}
            </div>
            <div className={styles.faq__responses}>
                {isFaqDataLoading ? (
                    <LoadingSection />
                ) : (
                    faqData && (
                        <FaqResponsesSection
                            data={faqData.responses}
                            selectedFaqItem={selectedFaqItem}
                            getDataFromApi={refetchFaqData}
                            canDelete={canDeleteFaq}
                        />
                    )
                )}
            </div>
            <div className={styles.faq__examples}>
                {isFaqDataLoading ? (
                    <LoadingSection />
                ) : (
                    faqData && (
                        <FaqExamplesSection
                            data={faqData.examples}
                            selectedFaqItem={selectedFaqItem}
                            getDataFromApi={refetchFaqData}
                            canDelete={canDeleteFaq}
                        />
                    )
                )}
            </div>
        </main>
    )
}

export default Faq
